import { gql } from 'graphql-tag'

/**
 * Whether feedback already exists for a support conversation. The write is a strict
 * one-row-per-conversation create, so the CWA form checks this first (and again after a
 * failed submit) to show an already-submitted notice instead of a doomed form.
 *
 * CWA-only — see `createSupportConversationFeedback.ts`.
 */
export const GET_SUPPORT_CONVERSATION_FEEDBACK = gql`
  query getSupportConversationFeedback($conversationId: ID!) {
    getSupportConversationFeedback(conversationId: $conversationId) {
      conversationId
      createdAt
    }
  }
`
